import { isOwnedStation } from '../helpers';
import { useStationsFinder } from './useStations';
import { Station } from '@app/core/types/stations';

/**
 * Returns the station when it exists and is owned by the current client.
 * Returns null when the id is missing, the station is not found, or it is shared.
 */
export function useOwnedStation(stationId: string | undefined | null): Station | null {
  const findStation = useStationsFinder();

  if (!stationId) {
    return null;
  }

  const station = findStation(stationId);
  if (!station || !isOwnedStation(station)) {
    return null;
  }

  return station;
}
